import ApiIntegrationsRepository from "../Repositories/Integrations/ApiIntegrationsRepository";
import type {
  BaseIntegrationsRepository,
  IngestServerOption,
  IntegrationUser,
  ViewersResponse,
  AllUsersResponse,
} from "../Repositories/Integrations/BaseIntegrationsRepository.interface";

class IntegrationsService {
  private Repository: BaseIntegrationsRepository;

  constructor() {
    // For now only api type is supported
    this.Repository = new ApiIntegrationsRepository();
  }

  async getIngest(platform: string): Promise<IngestServerOption[] | null> {
    return this.Repository.getIngest(platform);
  }

  async getUserIntegrations(platform: string): Promise<IntegrationUser | null> {
    return this.Repository.getUserIntegrations(platform);
  }

  async getAllUserIntegrations(): Promise<AllUsersResponse | null> {
    return this.Repository.getAllUserIntegrations();
  }

  async authIntegration(platform: string): Promise<boolean> {
    return this.Repository.authIntegration(platform);
  }

  async logoutIntegration(platform: string): Promise<boolean> {
    return this.Repository.logoutIntegration(platform);
  }

  async getViewers(): Promise<ViewersResponse | null> {
    return this.Repository.getViewers();
  }
}

export default IntegrationsService;
